var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassportIdDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25368_25036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 18.5001H26",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 21.5001H26",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 12.5001H11.75C11.3358 12.5001 11 12.8359 11 13.2501V26.7501C11 27.1643 11.3358 27.5001 11.75 27.5001H28.25C28.6642 27.5001 29 27.1643 29 26.7501V13.2501C29 12.8359 28.6642 12.5001 28.25 12.5001Z",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21.5001C18.2426 21.5001 19.25 20.4928 19.25 19.2501C19.25 18.0075 18.2426 17.0001 17 17.0001C15.7574 17.0001 14.75 18.0075 14.75 19.2501C14.75 20.4928 15.7574 21.5001 17 21.5001Z",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 23.7501C14.3328 22.4564 15.6022 21.5001 17 21.5001C18.3978 21.5001 19.6681 22.4554 20 23.7501",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25368_25036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.00012)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportIdDoc);
export default __webpack_public_path__ + "static/media/PassportIDDoc.a5cc63df73bf6ad2ef01a80f9bd66ce1.svg";
export { ForwardRef as ReactComponent };